import { Action } from '@ngrx/store';


export enum EMaterialActions {
    GetAllMaterialStock = '[Material] Get All Material Stock',
    GetAllMaterialStockSuccess = '[Material] Set All Material Stock Success',
    GetAllMaterialStockError = ' Set All Material Stock Error',
    GetAllMaterials = '[Material] Get All Materials',
    GetAllMaterialsByCompanyId = '[Material] Get All By Company ID Materials',
    GetAllMaterialsSuccess = '[Material] Set All Materials Success',
    GetAllMaterialsByCompanyIdSuccess = '[Material] Set All Materials By Company ID Success',
    GetAllMaterialsError = ' Set All Materials Error',
    GetAllMaterialByCompanyIdError = ' Set All Materials By Company ID Error',
    GetMaterialsByStatusId = '[Material] Get Materials By StatusId',
    GetMaterialsByStatusIdSuccess = '[Material] Get Materials By StatusId Success',
    GetMaterialsByStatusIdError = '[] Get Materials By StatusId Error',
    GetMaterialsByAgentId = '[Material] Get Materials By AgentId',
    GetMaterialsByAgentIdSuccess = '[Material] Get Materials By AgentId Success',
    GetMaterialsByAgentIdError = '[] Get Materials By AgentId Error',
    AddMaterial = '[Material] Get Add Materials',
    GetAddMaterialSuccess = '[Material] Set Add Materials Success',
    GetAddMaterialError = ' Set Add Materials Error',
    ImportMaterial = '[Material] Import Materials',
    ImportMaterialSuccess = '[Material] Import Materials Success',
    ImportMaterialError = '[] Import Materials Error',
    EditMaterial = '[Material] Get Edit Materials',
    GetEditMaterialSuccess = '[Material] Set Edit Materials Success',
    GetEditMaterialError = ' Set Edit Materials Error',
    GetMaterialCode = 'Get Material Code',
    GetMaterialCodeSuccess = 'Set Material Code Success',
    GetMaterialCodeError = 'Set Material Code Error',
    InActivateMaterial = 'InActivate Material ',
    InActivateMaterialSuccess = 'InActivate Material Success',
    InActivateMaterialError = 'InActivate Material Error',
    GetMatInventoryDetails = '[Material] Get Mat Inventory Details',
    GetMatInventorySuccess = '[Material] Get Mat Inventory Success',
    GetMatInventoryError = '[] Get Mat Inventory Error',
    AddType = '[Material] Get Add Type',
    GetAddTypeSuccess = '[Material] Get Add Type Success',
    GetAddTypeError = '[] Get Add Type Error',
    AddUOM = '[Material] Get Add UOM',
    GetAddUOMSuccess = '[Material] Get Add UOM Success',
    GetAddUOMError = '[] Get Add UOM Error',
    AddAlergens = '[Material] Get Add Alergens',
    GetAddAlergensSuccess = '[Material] Get Add Alergens Success',
    GetAddAlergensError = '[] Get Add Alergens Error',
    GetSubGroupType = '[Material] Get Sub GroupType',
    GetSubGroupTypeSuccess = '[Material] Get Sub Group Type Success',
    GetSubGroupTypeError = '[] Get Sub Group Type Error',

    //importSheet
    ImportExcelSheet = '[Material] Import Excel Sheet',
    GetImportExcelSheetSuccess = '[Material] Get Import Excel Sheet Success',
    GetImportExcelSheetError = '[] Get Import Excel Sheet Error',
    
}

export class GetAllMaterialStock implements Action {
    public readonly type = EMaterialActions.GetAllMaterialStock;
    constructor(public payload: any) {}
}
export class GetAllMaterialStockSuccess implements Action {
    public readonly type = EMaterialActions.GetAllMaterialStockSuccess;
    constructor(public payload: any) {
    }
}
export class GetAllMaterialStockError implements Action {
    public readonly type = EMaterialActions.GetAllMaterialStockError;
    constructor(public payload: any) {}
}

export class GetAllMaterials implements Action {
    public readonly type = EMaterialActions.GetAllMaterials;
    constructor(public payload: any) {}
}
export class GetAllMaterialsSuccess implements Action {
    public readonly type = EMaterialActions.GetAllMaterialsSuccess;
    constructor(public payload: any) {
    }
}
export class GetAllMaterialsError implements Action {
    public readonly type = EMaterialActions.GetAllMaterialsError;
    constructor(public payload: any) {}
}
export class GetAllMaterialsByCompanyId implements Action {
    public readonly type = EMaterialActions.GetAllMaterialsByCompanyId;
    constructor(public payload: any) {}
}
export class GetAllMaterialsByCompanyIdSuccess implements Action {
    public readonly type = EMaterialActions.GetAllMaterialsByCompanyIdSuccess;
    constructor(public payload: any) {
    }
}
export class GetAllMaterialByCompanyIdError implements Action {
    public readonly type = EMaterialActions.GetAllMaterialByCompanyIdError;
    constructor(public payload: any) {}
}
export class GetMaterialsByStatusId implements Action {
    public readonly type = EMaterialActions.GetMaterialsByStatusId;
    constructor(public payload: any) {}
}
export class GetMaterialsByStatusIdSuccess implements Action {
    public readonly type = EMaterialActions.GetMaterialsByStatusIdSuccess;
    constructor(public payload: any) {
    }
}
export class GetMaterialsByStatusIdError implements Action {
    public readonly type = EMaterialActions.GetMaterialsByStatusIdError;
    constructor(public payload: any) {}
}
export class GetMaterialsByAgentId implements Action {
    public readonly type = EMaterialActions.GetMaterialsByAgentId;
    constructor(public payload: any) {}
}
export class GetMaterialsByAgentIdSuccess implements Action {
    public readonly type = EMaterialActions.GetMaterialsByAgentIdSuccess;
    constructor(public payload: any) {
    }
}
export class GetMaterialsByAgentIdError implements Action {
    public readonly type = EMaterialActions.GetMaterialsByAgentIdError;
    constructor(public payload: any) {}
}
export class AddMaterial implements Action {
    public readonly type = EMaterialActions.AddMaterial;
    constructor(public payload: any) {}
}
export class GetAddMaterialSuccess implements Action {
    public readonly type = EMaterialActions.GetAddMaterialSuccess;
    constructor(public payload: any) {}
}
export class GetAddMaterialError implements Action {
    public readonly type = EMaterialActions.GetAddMaterialError;
    constructor(public payload: any) {}
}
export class ImportMaterial implements Action {
    public readonly type = EMaterialActions.ImportMaterial;
    constructor(public payload: any) {}
}
export class ImportMaterialSuccess implements Action {
    public readonly type = EMaterialActions.ImportMaterialSuccess;
    constructor(public payload: any) {}
}
export class ImportMaterialError implements Action {
    public readonly type = EMaterialActions.ImportMaterialError;
    constructor(public payload: any) {}
}
export class EditMaterial implements Action {
    public readonly type = EMaterialActions.EditMaterial;
    constructor(public payload: any) {}
}
export class GetEditMaterialSuccess implements Action {
    public readonly type = EMaterialActions.GetEditMaterialSuccess;
    constructor(public payload: any) {}
}
export class GetEditMaterialError implements Action {
    public readonly type = EMaterialActions.GetEditMaterialError;
    constructor(public payload: any) {}
}
export class GetMaterialCode implements Action {
    public readonly type = EMaterialActions.GetMaterialCode;
    constructor(public payload: any) {}
}
export class GetMaterialCodeSuccess implements Action {
    public readonly type = EMaterialActions.GetMaterialCodeSuccess;
    constructor(public payload: any) {}
}
export class GetMaterialCodeError implements Action {
    public readonly type = EMaterialActions.GetMaterialCodeError;
    constructor(public payload: any) {}
}
export class InActivateMaterial implements Action {
    public readonly type = EMaterialActions.InActivateMaterial;
    constructor(public payload: any) {}
}
export class InActivateMaterialSuccess implements Action {
    public readonly type = EMaterialActions.InActivateMaterialSuccess;
    constructor(public payload: any) {}
}
export class InActivateMaterialError implements Action {
    public readonly type = EMaterialActions.InActivateMaterialError;
    constructor(public payload: any) {}
}
export class GetMatInventoryDetails implements Action {
    public readonly type = EMaterialActions.GetMatInventoryDetails;
    constructor(public payload: any) {}
}
export class GetMatInventorySuccess implements Action {
    public readonly type = EMaterialActions.GetMatInventorySuccess;
    constructor(public payload: any) {}
}
export class GetMatInventoryError implements Action {
    public readonly type = EMaterialActions.GetMatInventoryError;
    constructor(public payload: any) {}
}
export class AddType implements Action {
    public readonly type = EMaterialActions.AddType;
    constructor(public payload: any) {}
}
export class GetAddTypeSuccess implements Action {
    public readonly type = EMaterialActions.GetAddTypeSuccess;
    constructor(public payload: any) {}
}
export class GetAddTypeError implements Action {
    public readonly type = EMaterialActions.GetAddTypeError;
    constructor(public payload: any) {}
}
export class AddUOM implements Action {
    public readonly type = EMaterialActions.AddUOM;
    constructor(public payload: any) {}
}
export class GetAddUOMSuccess implements Action {
    public readonly type = EMaterialActions.GetAddUOMSuccess;
    constructor(public payload: any) {}
}
export class GetAddUOMError implements Action {
    public readonly type = EMaterialActions.GetAddUOMError;
    constructor(public payload: any) {}
}
export class AddAlergens implements Action {
    public readonly type = EMaterialActions.AddAlergens;
    constructor(public payload: any) {}
}
export class GetAddAlergensSuccess implements Action {
    public readonly type = EMaterialActions.GetAddAlergensSuccess;
    constructor(public payload: any) {}
}
export class GetAddAlergensError implements Action {
    public readonly type = EMaterialActions.GetAddAlergensError;
    constructor(public payload: any) {}
}
export class GetSubGroupType implements Action {
    public readonly type = EMaterialActions.GetSubGroupType;
    constructor(public payload: any) {}
}
export class GetSubGroupTypeSuccess implements Action {
    public readonly type = EMaterialActions.GetSubGroupTypeSuccess;
    constructor(public payload: any) {}
}
export class GetSubGroupTypeError implements Action {
    public readonly type = EMaterialActions.GetSubGroupTypeError;
    constructor(public payload: any) {}
}
export class ImportExcelSheet implements Action {
    public readonly type = EMaterialActions.ImportExcelSheet;
    constructor(public payload: any) {}
}
export class GetImportExcelSheetSuccess implements Action {
    public readonly type = EMaterialActions.GetImportExcelSheetSuccess;
    constructor(public payload: any) {}
}
export class GetImportExcelSheetError implements Action {
    public readonly type = EMaterialActions.GetImportExcelSheetError;
    constructor(public payload: any) {}
}
export type MaterialAction =    GetAllMaterialStock | GetAllMaterialStockSuccess | GetAllMaterialStockError |
                                GetAllMaterials | GetAllMaterialsSuccess | GetAllMaterialsError |
                                GetAllMaterialsByCompanyId | GetAllMaterialsByCompanyIdSuccess | GetAllMaterialByCompanyIdError |
                                AddMaterial | GetAddMaterialSuccess | GetAddMaterialError |
                                ImportMaterial | ImportMaterialSuccess | ImportMaterialError |
                                EditMaterial | GetEditMaterialSuccess | GetEditMaterialError | GetMaterialCode |
                                GetMaterialCodeSuccess | GetMaterialCodeError | InActivateMaterial |
                                InActivateMaterialSuccess | InActivateMaterialError|GetMatInventoryDetails|GetMatInventorySuccess|
                                GetMatInventoryError|AddType|GetAddTypeSuccess|GetAddTypeError| AddUOM|GetAddUOMSuccess|
                                GetAddUOMError| AddAlergens|GetAddAlergensSuccess|GetAddAlergensError|
                                GetSubGroupType|GetSubGroupTypeSuccess|GetSubGroupTypeError|GetMaterialsByStatusId|
                                GetMaterialsByStatusIdSuccess|GetMaterialsByStatusIdError|GetMaterialsByAgentId|
                                GetMaterialsByAgentIdSuccess| GetMaterialsByAgentIdError | ImportExcelSheet|
                                GetImportExcelSheetSuccess|GetImportExcelSheetError;